<template>
  <div class="loading-spinner" :class="[`spinner-${size}`, `spinner-${variant}`]">
    <div class="spinner-container">
      <div class="spinner" />
      <div v-if="text" class="spinner-text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    size: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large'].includes(value),
    },
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'secondary', 'white'].includes(value),
    },
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/variable.scss';

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.spinner {
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.spinner-small .spinner {
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
}

.spinner-medium .spinner {
  width: 40px;
  height: 40px;
  border: 3px solid transparent;
}

.spinner-large .spinner {
  width: 60px;
  height: 60px;
  border: 4px solid transparent;
}

.spinner-primary .spinner {
  border-top: 2px solid $primary;
  border-right: 2px solid $primary;
  border-bottom: 2px solid transparent;
  border-left: 2px solid transparent;
}

.spinner-primary.spinner-medium .spinner {
  border-top: 3px solid $primary;
  border-right: 3px solid $primary;
  border-bottom: 3px solid transparent;
  border-left: 3px solid transparent;
}

.spinner-primary.spinner-large .spinner {
  border-top: 4px solid $primary;
  border-right: 4px solid $primary;
  border-bottom: 4px solid transparent;
  border-left: 4px solid transparent;
}

.spinner-secondary .spinner {
  border-top: 2px solid $secondary;
  border-right: 2px solid $secondary;
  border-bottom: 2px solid transparent;
  border-left: 2px solid transparent;
}

.spinner-secondary.spinner-medium .spinner {
  border-top: 3px solid $secondary;
  border-right: 3px solid $secondary;
  border-bottom: 3px solid transparent;
  border-left: 3px solid transparent;
}

.spinner-secondary.spinner-large .spinner {
  border-top: 4px solid $secondary;
  border-right: 4px solid $secondary;
  border-bottom: 4px solid transparent;
  border-left: 4px solid transparent;
}

.spinner-white .spinner {
  border-top: 2px solid $white;
  border-right: 2px solid $white;
  border-bottom: 2px solid transparent;
  border-left: 2px solid transparent;
}

.spinner-white.spinner-medium .spinner {
  border-top: 3px solid $white;
  border-right: 3px solid $white;
  border-bottom: 3px solid transparent;
  border-left: 3px solid transparent;
}

.spinner-white.spinner-large .spinner {
  border-top: 4px solid $white;
  border-right: 4px solid $white;
  border-bottom: 4px solid transparent;
  border-left: 4px solid transparent;
}

.spinner-text {
  font-size: 14px;
  color: $grey;
  font-weight: 500;
}

.spinner-primary .spinner-text {
  color: $primary;
}

.spinner-secondary .spinner-text {
  color: $secondary;
}

.spinner-white .spinner-text {
  color: $white;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
